module.exports = __webpack_public_path__ + "img/PART.0bbc7b95.svg";